import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText, Truck, CreditCard, ShieldCheck, AlertTriangle, RotateCcw } from 'lucide-react';

export const CGV = () => (
    <div className="min-h-screen bg-sand" data-testid="cgv-page">
        <div className="max-w-3xl mx-auto px-4 py-12 sm:py-16">
            <Link to="/" className="inline-flex items-center gap-2 text-sm text-jungle/60 hover:text-jungle mb-8 transition-colors" data-testid="back-home-link">
                <ArrowLeft className="w-4 h-4" /> Retour a l'accueil
            </Link>

            <h1 className="font-heading font-bold text-3xl sm:text-4xl text-jungle mb-10">Conditions Generales de Vente</h1>

            <div className="space-y-10 text-jungle/80 text-sm leading-relaxed">
                <section>
                    <div className="flex items-center gap-2 mb-3">
                        <FileText className="w-5 h-5 text-leaf" />
                        <h2 className="font-heading font-semibold text-lg text-jungle">Article 1 - Objet et champ d'application</h2>
                    </div>
                    <div className="pl-7 space-y-2">
                        <p>Les presentes Conditions Generales de Vente (CGV) regissent l'ensemble des relations commerciales entre PRIXDEAL et ses clients professionnels (B2B) dans le cadre de la vente de fruits, legumes et autres produits alimentaires et non alimentaires.</p>
                        <p>Toute commande passee sur le site prix-deal.fr implique l'acceptation sans reserve des presentes CGV par le client professionnel.</p>
                    </div>
                </section>

                <section>
                    <div className="flex items-center gap-2 mb-3">
                        <CreditCard className="w-5 h-5 text-leaf" />
                        <h2 className="font-heading font-semibold text-lg text-jungle">Article 2 - Prix et paiement</h2>
                    </div>
                    <div className="pl-7 space-y-2">
                        <p>Les prix sont exprimes en euros hors taxes (HT). Ils sont susceptibles de varier en fonction des cours du marche, notamment pour les produits frais.</p>
                        <p>Les prix definitifs sont ceux confirmes au moment de la validation de la commande par PRIXDEAL.</p>
                        <p>Les produits marques "Prix sur demande" necessitent une demande de prix prealable.</p>
                        <p><strong>Modalites de paiement :</strong> Le paiement s'effectue selon les conditions convenues entre PRIXDEAL et le client (virement bancaire, cheque, especes). Le delai de paiement est fixe a 30 jours a compter de la date de facturation, sauf accord contraire.</p>
                        <p>En cas de retard de paiement, des penalites de retard seront appliquees au taux legal en vigueur, ainsi qu'une indemnite forfaitaire de 40 euros pour frais de recouvrement.</p>
                    </div>
                </section>

                <section>
                    <div className="flex items-center gap-2 mb-3">
                        <FileText className="w-5 h-5 text-leaf" />
                        <h2 className="font-heading font-semibold text-lg text-jungle">Article 3 - Commandes et demandes de prix</h2>
                    </div>
                    <div className="pl-7 space-y-2">
                        <p>Les commandes peuvent etre passees directement via le site ou par contact telephonique / WhatsApp.</p>
                        <p>Pour les produits sans prix affiche, le client peut effectuer une demande de prix via la plateforme. PRIXDEAL s'engage a repondre dans les meilleurs delais.</p>
                        <p>PRIXDEAL se reserve le droit de refuser ou d'annuler toute commande en cas de probleme d'approvisionnement, d'erreur de prix ou de litige avec le client.</p>
                    </div>
                </section>

                <section>
                    <div className="flex items-center gap-2 mb-3">
                        <Truck className="w-5 h-5 text-leaf" />
                        <h2 className="font-heading font-semibold text-lg text-jungle">Article 4 - Livraison</h2>
                    </div>
                    <div className="pl-7 space-y-2">
                        <p>Les livraisons sont effectuees a l'adresse indiquee par le client lors de la commande, dans la zone de livraison definie par PRIXDEAL.</p>
                        <p>Les delais de livraison sont donnes a titre indicatif. Un retard de livraison ne peut donner lieu a aucune penalite, indemnite ou annulation de commande.</p>
                        <p>Le client est tenu de verifier l'etat des marchandises a la reception et de signaler toute anomalie dans un delai de 24 heures.</p>
                    </div>
                </section>

                <section>
                    <div className="flex items-center gap-2 mb-3">
                        <RotateCcw className="w-5 h-5 text-leaf" />
                        <h2 className="font-heading font-semibold text-lg text-jungle">Article 5 - Reclamations et retours</h2>
                    </div>
                    <div className="pl-7 space-y-2">
                        <p>Toute reclamation concernant la qualite ou la conformite des produits livres doit etre formulee par ecrit (email ou courrier) dans un delai de 24 heures suivant la livraison, accompagnee de photos justificatives.</p>
                        <p>Apres verification, PRIXDEAL procedera, selon le cas, a un remplacement des produits ou a un avoir sur la prochaine commande.</p>
                        <p>En raison de la nature perissable des produits, aucun retour ne sera accepte sans accord prealable de PRIXDEAL.</p>
                    </div>
                </section>

                <section>
                    <div className="flex items-center gap-2 mb-3">
                        <ShieldCheck className="w-5 h-5 text-leaf" />
                        <h2 className="font-heading font-semibold text-lg text-jungle">Article 6 - Garanties et responsabilite</h2>
                    </div>
                    <div className="pl-7 space-y-2">
                        <p>PRIXDEAL garantit la conformite des produits livres aux normes sanitaires en vigueur.</p>
                        <p>La responsabilite de PRIXDEAL ne saurait etre engagee en cas de mauvaise conservation des produits apres livraison, de force majeure ou de tout evenement imprevisible et irresistible.</p>
                    </div>
                </section>

                <section>
                    <div className="flex items-center gap-2 mb-3">
                        <AlertTriangle className="w-5 h-5 text-leaf" />
                        <h2 className="font-heading font-semibold text-lg text-jungle">Article 7 - Litiges</h2>
                    </div>
                    <div className="pl-7 space-y-2">
                        <p>Les presentes CGV sont soumises au droit francais.</p>
                        <p>En cas de litige, les parties s'efforceront de trouver une solution amiable. A defaut, le Tribunal de Commerce de Creteil sera seul competent.</p>
                    </div>
                </section>
            </div>

            <div className="mt-12 pt-8 border-t border-jungle/10 flex flex-wrap gap-4 text-xs text-jungle/50">
                <Link to="/mentions-legales" className="hover:text-jungle transition-colors">Mentions legales</Link>
                <Link to="/politique-confidentialite" className="hover:text-jungle transition-colors">Politique de confidentialite</Link>
            </div>
        </div>
    </div>
);
